import { useCallback, useContext } from 'react';
import { useMutation } from '@tanstack/react-query';
import type { SaveTaggedMoment } from '@trinity/chat/api/interfaces/transcripts';
import { IsSavingTaggedMomentContext, SaveTaggedMomentContext, SetTaggedMomentEditParamsContext } from './context';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';

type Props = {
  onSuccess?: (data: SaveTaggedMoment.Response) => Promise<void>;
} & ChildrenProps;

export const SaveTaggedMomentFormContainer = ({
  onSuccess,
  ...props
}: Props) => {

  const setModalParams = useContext(SetTaggedMomentEditParamsContext);

  const apiClient = useChatApiClient();

  const saveTaggedMoment = useCallback((params: SaveTaggedMoment.Request) => {
    return apiClient.transcripts.saveTaggedMoment(params);
  }, [apiClient]);

  const mutationFn = useCallback((params: SaveTaggedMoment.Request) => {
    return saveTaggedMoment(params);
  }, [saveTaggedMoment]);

  const handleSuccess = useCallback(async (data: SaveTaggedMoment.Response) => {
    await onSuccess?.(data);
    setModalParams(null);
  }, [onSuccess, setModalParams]);

  const mutation = useMutation({
    mutationFn,
    onSuccess: handleSuccess,
  });

  return (
    <IsSavingTaggedMomentContext.Provider value={mutation.isPending}>
      <SaveTaggedMomentContext.Provider value={mutation.mutateAsync}>
        {props.children}
      </SaveTaggedMomentContext.Provider>
    </IsSavingTaggedMomentContext.Provider>
  );
};